import type { CSSProperties, FC } from 'react';
import { memo } from 'react';
import { Picture } from '@ui';
import { starYellow, starGreyRecipeRating } from '@images';
import './index.scss';

interface FiveStarRatingProps {
  height?: number;
  rating: number;
  className?: string;
  justify?: CSSProperties['justifyContent'];
  margin?: CSSProperties['margin'];
  noMargin?: boolean;
  onlyOneStar?: boolean;
}

const FiveStarRating: FC<FiveStarRatingProps> = ({
  height = 16,
  rating,
  className,
  justify,
  margin = 0,
  noMargin,
  onlyOneStar
}) => {
  const wrapperStyle = {
    justifyContent: justify
  };
  const starStyle = {
    margin: `${margin}px`
  };
  const styleMarginZero = {
    margin: '0'
  };
  if (onlyOneStar) {
    return (
      <div
        className={`fivestar-rating fivestar-rating--onlyOneStar ${
          className || ''
        }`}
      >
        <Picture
          icon={starYellow}
          height='16'
          className='fivestar-rating__icon'
        />
        <div className='fivestar-rating__text'>{rating}</div>
      </div>
    );
  }
  return (
    <div
      style={wrapperStyle}
      className={`fivestar-rating${
        noMargin ? ' fivestar-rating--no-margin' : ''
      } ${className || ''}`}
    >
      {[1, 2, 3, 4, 5].map((e, i) => (
        <Picture
          style={i === 4 ? styleMarginZero : starStyle}
          key={i}
          icon={i < rating ? starYellow : starGreyRecipeRating}
          height={height}
        />
      ))}
    </div>
  );
};

export default memo(FiveStarRating);
